export const ImpairmentStatus = Object.freeze({
  PREENCHIMENTO: 1,
  APROVACAO: 2,
  REALIZADO: 3,
  APROVADO: 4,
  REPROVADO: 5,
});
